import _ from 'lodash'

const ErrorContent = ({ className, message, error }) => {
  const errors = Array.isArray(error)
    ? error
    : [error]

  return (
    <div className={className}>
      {
        _.isEmpty(error) && (
          <>
            {message}
          </>
        )
      }
      {
        _.map(
          errors,
          (error, idx) => {
            return (
              <>
                {idx !== 0 && <br />}
                {`${error.code} ${error.message}`}
              </>
            )
          })}
    </div>
  )
}

export default ErrorContent
